var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _path8, _path9, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path0, _path1, _path10, _path11, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _path12, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _path13, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _path14, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _path15, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _path16, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _path17, _rect57, _path18, _path19, _path20, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _path21, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _path22, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _path23, _path24, _path25, _path26, _path27, _path28, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClient10(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 664,
    height: 502,
    viewBox: "0 0 664 502",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.183 95.4558L658.124 258.669C659.815 259.648 660.392 261.812 659.413 263.503C659.102 264.042 658.653 264.488 658.114 264.798L479.342 367.513C477.158 368.768 474.471 368.767 472.288 367.511L192.779 206.68C191.086 205.705 190.503 203.543 191.477 201.849C191.785 201.315 192.227 200.87 192.759 200.559L372.626 95.463C373.724 94.8213 375.082 94.8186 376.183 95.4558Z",
    fill: "#13181E",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M277.715 235.933L179.664 292.969",
    stroke: "#1A2024",
    strokeOpacity: 0.3,
    strokeLinecap: "round",
    strokeDasharray: "3 3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M424.313 320.258L326.129 384.865L398.587 422.034",
    stroke: "#1A2024",
    strokeOpacity: 0.3,
    strokeLinecap: "round",
    strokeDasharray: "3 3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M288.551 124L204.551 81",
    stroke: "#1A2024",
    strokeOpacity: 0.3,
    strokeLinecap: "round",
    strokeDasharray: "3 3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M373.303 82.8214C374.727 82.0572 376.935 82.0653 378.341 82.84L657.459 236.573L657.458 244.04L475.243 349.233C473.808 350.062 471.481 350.062 470.046 349.233L191.024 188.154L191.026 180.678L373.303 82.8214Z",
    fill: "#2F3A50"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M373.238 75.4931C374.673 74.6647 376.999 74.6647 378.434 75.4931L657.456 236.573L475.241 341.766C473.806 342.594 471.48 342.594 470.045 341.766L191.022 180.686L373.238 75.4931Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M405.681 124.85C406.701 124.261 408.402 124.287 409.478 124.908C410.554 125.529 410.599 126.511 409.579 127.1C408.557 127.69 406.857 127.663 405.782 127.042C404.706 126.421 404.66 125.44 405.681 124.85ZM416.757 131.956L408.556 132.912L407.748 129.657L395.208 130.896L413.396 141.396L416.757 131.956Z",
    fill: "#3E495F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 213.4,
    height: 16.259,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 435.678 139.025)",
    fill: "#F3F5F8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M605.358 248.281L605.358 245.917C606.273 245.833 607.152 245.589 607.856 245.183C609.627 244.16 609.627 242.497 607.856 241.475C606.085 240.453 603.204 240.453 601.433 241.475C599.662 242.497 599.663 244.16 601.433 245.182C602.105 245.57 602.935 245.81 603.805 245.904L603.805 248.281L605.358 248.281V248.281ZM602.375 242.019C603.627 241.296 605.663 241.296 606.914 242.019C608.166 242.741 608.166 243.917 606.914 244.639C605.663 245.362 603.627 245.362 602.375 244.639C601.124 243.916 601.124 242.741 602.375 242.019V242.019Z",
    fill: "#C9C7C2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M417.244 100.896C418.679 100.068 421.005 100.068 422.44 100.896L654.861 235.073C656.296 235.901 656.296 237.244 654.861 238.073L641.618 245.718L404.001 108.541L417.244 100.896Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 71.1332,
    height: 5.08094,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 422.094 106.217)",
    fill: "#E2E5E8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 71.1332,
    height: 5.08094,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 421.221 106.725)",
    fill: "#F3F5F8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 15.2428,
    height: 5.08094,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 589.332 203.764)",
    fill: "#F3F5F8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 15.2428,
    height: 5.08094,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 606.934 213.925)",
    fill: "#F3F5F8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 5.08094,
    height: 5.08094,
    rx: 2.54047,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 628.932 226.627)",
    fill: "#F3F5F8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 15.2428,
    height: 5.08094,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 634.199 229.675)",
    fill: "#F3F5F8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 274.371,
    height: 1.01619,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 404.885 108.033)",
    fill: "#E4E4E4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M373.234 75.4931C374.669 74.6647 376.995 74.6647 378.43 75.4931L419.835 99.3962L235.022 206.089L191.019 180.686L373.234 75.4931Z",
    fill: "#3E495F"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.953 82.6301L368.887 86.1319L383.788 94.7338L389.853 91.2321L374.953 82.6302L374.953 82.6301ZM375.317 86.5097C375.159 86.6008 374.964 86.6566 374.782 86.7056C374.6 86.7544 374.405 86.768 374.211 86.7677C374.017 86.7684 373.825 86.744 373.65 86.6963C373.447 86.6421 373.261 86.5681 373.101 86.4774C372.93 86.3786 372.796 86.273 372.722 86.1605C372.638 86.0572 372.6 85.9437 372.611 85.83C372.61 85.7175 372.67 85.6263 372.755 85.521C372.839 85.4158 372.973 85.3247 373.13 85.2337L374.72 84.3162L375.208 84.5983L373.619 85.5158C373.522 85.5718 373.425 85.6277 373.376 85.6839C373.316 85.747 373.292 85.8032 373.28 85.8664C373.268 85.9297 373.293 85.9859 373.33 86.0492C373.367 86.1125 373.44 86.1688 373.538 86.2253C373.636 86.2816 373.733 86.324 373.843 86.3453C373.952 86.3666 374.05 86.3809 374.172 86.3811C374.281 86.3743 374.403 86.3746 374.524 86.3466C374.634 86.3117 374.755 86.2839 374.853 86.2278L376.442 85.3104L376.93 85.5924L375.329 86.5168L375.317 86.5097ZM376.35 88.3388C376.301 88.3106 376.289 88.2895 376.276 88.2544C376.264 88.2267 376.264 88.1977 376.276 88.17L376.563 87.3554C376.576 87.3231 376.584 87.2902 376.587 87.257C376.587 87.2289 376.574 87.2078 376.526 87.1797L376.318 87.0598L375.226 87.6901L374.738 87.4081L377.406 85.8673L378.2 86.3256C378.384 86.4315 378.506 86.53 378.604 86.6285C378.702 86.7272 378.739 86.8185 378.764 86.9029C378.776 86.9943 378.765 87.0717 378.704 87.1488C378.644 87.226 378.571 87.296 378.462 87.3591C378.377 87.4081 378.28 87.45 378.171 87.485C378.067 87.5143 377.956 87.5354 377.842 87.5477C377.733 87.5545 377.611 87.5541 377.489 87.5399C377.368 87.5257 377.245 87.4973 377.124 87.4689C377.148 87.5252 377.149 87.5955 377.125 87.6517L376.802 88.5997L376.35 88.3389L376.35 88.3388ZM379.497 89.5957C379.364 89.6307 379.206 89.6374 379.072 89.63C378.913 89.6228 378.755 89.6013 378.596 89.5519C378.421 89.4976 378.261 89.4286 378.121 89.3472L377.07 88.7408L379.727 87.207L380.692 87.7639C380.863 87.8627 380.985 87.9613 381.071 88.0528C381.156 88.1444 381.206 88.2288 381.23 88.3132C381.243 88.3905 381.231 88.4679 381.183 88.5379C381.135 88.6081 381.062 88.6783 380.953 88.7414C380.893 88.7763 380.82 88.8042 380.747 88.8322C380.669 88.8525 380.587 88.8665 380.503 88.8739C380.41 88.8818 380.315 88.8793 380.224 88.8664C380.118 88.8514 380.016 88.8299 379.919 88.8024C380.2 89.0631 380.19 89.2809 379.886 89.456C379.753 89.5188 379.619 89.5678 379.497 89.5957ZM381.443 91.279C381.406 91.2578 381.394 91.2227 381.369 91.1945C381.369 91.1664 381.345 91.1524 381.356 91.1313L381.683 90.7173L380.584 90.0829L379.879 90.264C379.842 90.271 379.806 90.278 379.745 90.2709C379.696 90.2706 379.66 90.2495 379.623 90.2284L379.244 90.0097L382.951 89.0683L383.452 89.3575L381.821 91.4975L381.443 91.279ZM384.386 92.9781L384.081 92.802C384.044 92.7808 384.02 92.7527 384.007 92.7316C383.995 92.7102 383.995 92.6824 384.007 92.6472L384.374 90.8279C384.337 90.8489 384.313 90.8771 384.289 90.9051C384.265 90.9331 384.228 90.9541 384.192 90.9752L382.554 91.9206L382.066 91.6386L384.734 90.0978L385.028 90.267C385.052 90.2812 385.052 90.2953 385.064 90.3023C385.076 90.3094 385.077 90.3234 385.089 90.3304C385.101 90.3375 385.101 90.3516 385.101 90.3655L385.101 90.4078L384.735 92.227C384.783 92.1989 384.807 92.1708 384.844 92.1499L386.566 91.1554L387.055 91.4375L384.386 92.9783L384.386 92.9781Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379.955 88.5986C380.101 88.6131 380.259 88.5781 380.392 88.5011C380.526 88.424 380.61 88.333 380.586 88.2486C380.573 88.1713 380.5 88.0726 380.329 87.9739L379.852 87.6989L379.003 88.1892L379.455 88.4501C379.626 88.5489 379.809 88.5843 379.955 88.5986V88.5986ZM382.614 89.6157C382.65 89.5806 382.687 89.5315 382.735 89.4894C382.663 89.5174 382.578 89.5383 382.517 89.5594C382.456 89.5802 382.359 89.6081 382.31 89.6222L381.083 89.9501L381.925 90.4366L382.505 89.7349C382.517 89.6998 382.566 89.6579 382.614 89.6157ZM379.543 88.9492C379.543 88.9009 379.526 88.853 379.493 88.8086C379.45 88.7486 379.388 88.6937 379.31 88.6465L378.761 88.3293L377.911 88.8196L378.473 89.144C378.553 89.1897 378.649 89.2257 378.754 89.2498C378.831 89.2688 378.914 89.2785 378.997 89.2785C379.07 89.2786 379.143 89.2646 379.216 89.2508C379.277 89.2299 379.338 89.2088 379.398 89.1738C379.459 89.1389 379.495 89.1037 379.531 89.0686C379.531 89.0265 379.555 88.9843 379.543 88.9492V88.9492ZM377.926 87.1049C378.059 87.0279 378.131 86.9297 378.119 86.8383C378.106 86.7471 378.02 86.6415 377.837 86.5357L377.531 86.3594L376.682 86.8496L376.988 87.0259C377.085 87.0823 377.135 87.1386 377.232 87.1669C377.33 87.1953 377.391 87.2165 377.488 87.2166C377.573 87.2237 377.646 87.2099 377.719 87.1959C377.792 87.168 377.853 87.1471 377.926 87.1051L377.926 87.1049ZM389.732 91.1614L383.666 94.6632L398.689 103.336L404.754 99.8339L389.732 91.1614ZM398.685 102.773L384.64 94.6651L389.735 91.7236L403.781 99.832L398.685 102.773V102.773Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M388.967 94.5049L387.996 95.0653L387.642 94.8608L390.25 93.355L391.019 93.7992C391.19 93.8979 391.3 93.9896 391.386 94.0811C391.472 94.1726 391.509 94.2639 391.534 94.3484C391.547 94.4397 391.523 94.5241 391.462 94.6012C391.402 94.6784 391.317 94.7556 391.196 94.8257C391.075 94.8956 390.941 94.9445 390.807 94.9794C390.666 95.0068 390.518 95.0207 390.369 95.0207C390.211 95.0135 390.053 94.992 389.894 94.9425C389.719 94.8882 389.558 94.8192 389.418 94.7378L388.991 94.491L388.966 94.505L388.967 94.5049ZM389.258 94.3369L389.685 94.5837C389.783 94.6402 389.893 94.6895 389.99 94.7178C390.088 94.7461 390.197 94.7674 390.295 94.7676C390.392 94.7678 390.502 94.761 390.587 94.7401C390.672 94.7192 390.769 94.6771 390.842 94.6352C391.011 94.5371 391.084 94.4389 391.071 94.3195C391.07 94.207 390.96 94.0872 390.753 93.9674L390.325 93.7206L389.258 94.3369ZM390.634 96.5882L390.28 96.3838L392.888 94.878L393.242 95.0825L390.634 96.5882ZM392.826 96.733L391.855 97.2934L391.501 97.0889L394.11 95.5831L394.879 96.0273C395.05 96.126 395.16 96.2177 395.246 96.3091C395.331 96.4006 395.369 96.492 395.393 96.5764C395.406 96.6678 395.382 96.7521 395.322 96.8293C395.261 96.9064 395.177 96.9836 395.055 97.0537C394.934 97.1236 394.8 97.1726 394.667 97.2075C394.525 97.2349 394.378 97.2488 394.229 97.2487C394.07 97.2414 393.912 97.22 393.753 97.1704C393.578 97.1162 393.418 97.0472 393.277 96.9658L392.85 96.7191L392.826 96.7331L392.826 96.733ZM393.117 96.565L393.544 96.8117C393.642 96.8681 393.752 96.9175 393.85 96.9459C393.947 96.9742 394.057 96.9953 394.154 96.9956C394.251 96.9958 394.361 96.9889 394.446 96.9681C394.531 96.9473 394.628 96.9052 394.701 96.8633C394.871 96.7652 394.943 96.667 394.93 96.5475C394.93 96.4351 394.82 96.3152 394.612 96.1954L394.185 95.9487L393.117 96.565V96.565ZM398.421 98.072L398.13 98.2401L396.872 97.5139L396.01 98.0112L397.036 98.6034L396.757 98.7645L395.731 98.1723L394.846 98.6835L396.104 99.4097L395.812 99.5778L394.2 98.6471L396.809 97.1413L398.421 98.072ZM398.162 99.6737L397.07 100.304L396.716 100.1L399.325 98.5937L400.07 99.0238C400.241 99.1226 400.363 99.2072 400.448 99.2987C400.534 99.3902 400.583 99.4745 400.608 99.559C400.621 99.6363 400.609 99.7136 400.549 99.7907C400.5 99.861 400.416 99.938 400.307 100.001C400.209 100.057 400.112 100.099 400.003 100.12C399.893 100.155 399.772 100.169 399.662 100.175C399.541 100.175 399.419 100.175 399.297 100.147C399.163 100.125 399.041 100.097 398.931 100.048C398.956 100.09 398.956 100.132 398.944 100.181L398.682 101.221L398.365 101.037C398.336 101.021 398.314 101.001 398.301 100.979C398.288 100.957 398.284 100.934 398.291 100.911L398.542 99.9766C398.541 99.9484 398.541 99.9204 398.529 99.8993C398.516 99.8781 398.48 99.857 398.431 99.8287L398.162 99.6737V99.6737ZM398.417 99.5267L398.783 99.7382C398.893 99.8016 398.991 99.8439 399.089 99.8723C399.186 99.9005 399.296 99.9218 399.393 99.922C399.49 99.9222 399.588 99.9224 399.673 99.9015C399.758 99.8805 399.843 99.8456 399.916 99.8035C400.073 99.7124 400.134 99.6213 400.109 99.5088C400.084 99.4104 399.973 99.2908 399.766 99.1709L399.375 98.9453L398.393 99.5125L398.417 99.5266L398.417 99.5267Z",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 32.518,
    height: 5.08094,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 356.086 94.531)",
    fill: "white"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 32.518,
    height: 5.08094,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 345.521 100.628)",
    fill: "white",
    fillOpacity: 0.2
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 32.518,
    height: 5.08094,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 334.967 106.725)",
    fill: "white",
    fillOpacity: 0.2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 32.518,
    height: 5.08094,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 324.42 112.821)",
    fill: "white",
    fillOpacity: 0.2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 32.518,
    height: 5.08094,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 313.855 118.918)",
    fill: "white",
    fillOpacity: 0.2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 32.518,
    height: 5.08094,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 303.293 125.015)",
    fill: "white",
    fillOpacity: 0.2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 32.518,
    height: 5.08094,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 292.729 131.111)",
    fill: "white",
    fillOpacity: 0.2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 32.518,
    height: 5.08094,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 282.162 137.208)",
    fill: "white",
    fillOpacity: 0.2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 32.518,
    height: 5.08094,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 271.598 143.305)",
    fill: "white",
    fillOpacity: 0.2
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    y: 0.499967,
    width: 245.934,
    height: 19.3238,
    rx: 2.5,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 382.435 136.735)",
    fill: "#F3F5F8",
    stroke: "#ECECEC"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 22.3561,
    height: 6.09713,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 561.541 247.242)",
    fill: "#00D7B3"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 20.3238,
    height: 3.04856,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 462.973 192.372)",
    fill: "#C9C7C2"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 30.4856,
    height: 3.04856,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 418.967 166.969)",
    fill: "#C9C7C2"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 30.4856,
    height: 3.04856,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 489.371 207.614)",
    fill: "#C9C7C2"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 20.3238,
    height: 3.04856,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 524.578 227.936)",
    fill: "#C9C7C2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M389.541 155.314L390.64 155.949L393.356 154.725L394.688 155.494L391.985 156.726L393.085 157.36L395.801 156.136L397.03 156.845L398.245 156.143L397.159 155.516L398.75 154.792L399.927 155.471L401.143 154.769L400.121 154.179L402.514 153.097L401.427 152.469L399.022 153.545L397.676 152.768L400.069 151.685L398.983 151.058L396.577 152.133L395.4 151.454L394.184 152.156L395.206 152.746L393.602 153.463L392.503 152.828L391.287 153.53L392.244 154.082L389.541 155.314ZM394.714 154.105L396.305 153.38L397.65 154.157L396.047 154.874L394.714 154.105Z",
    fill: "#C9C7C2"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    y: 0.499967,
    width: 9.16188,
    height: 9.16188,
    rx: 0.5,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 382.435 141.815)",
    fill: "white",
    stroke: "#ECECEC"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    y: 0.499967,
    width: 245.934,
    height: 19.3238,
    rx: 2.5,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 361.31 148.928)",
    fill: "#FC8A63",
    stroke: "#FC8A63"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 22.3561,
    height: 6.09713,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 540.416 259.436)",
    fill: "white"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 20.3238,
    height: 3.04856,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 441.854 204.565)",
    fill: "white",
    fillOpacity: 0.6
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 25.4047,
    height: 3.04856,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 397.85 179.162)",
    fill: "white",
    fillOpacity: 0.6
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 30.4856,
    height: 3.04856,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 468.252 219.807)",
    fill: "white",
    fillOpacity: 0.6
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 20.3238,
    height: 3.04856,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 503.455 240.129)",
    fill: "white",
    fillOpacity: 0.6
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M368.416 167.508L369.515 168.142L372.231 166.918L373.563 167.687L370.86 168.919L371.96 169.554L374.676 168.329L375.905 169.039L377.12 168.337L376.034 167.709L377.625 166.985L378.802 167.665L380.018 166.963L378.996 166.373L381.389 165.29L380.302 164.663L377.897 165.738L376.551 164.961L378.944 163.879L377.858 163.252L375.452 164.327L374.275 163.647L373.059 164.349L374.081 164.939L372.477 165.656L371.378 165.021L370.162 165.723L371.119 166.276L368.416 167.508ZM373.589 166.298L375.18 165.574L376.525 166.35L374.922 167.067L373.589 166.298Z",
    fill: "white"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    y: 0.499967,
    width: 9.16188,
    height: 9.16188,
    rx: 0.5,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 361.31 154.009)",
    fill: "white",
    stroke: "#ECECEC"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    y: 0.499967,
    width: 245.934,
    height: 19.3238,
    rx: 2.5,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 340.181 161.122)",
    fill: "#F3F5F8",
    stroke: "#ECECEC"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    width: 22.3561,
    height: 6.09713,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 519.287 271.629)",
    fill: "#00D7B3"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    width: 20.3238,
    height: 3.04856,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 420.713 216.758)",
    fill: "#C9C7C2"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    width: 32.518,
    height: 3.04856,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 376.709 191.355)",
    fill: "#C9C7C2"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    width: 30.4856,
    height: 3.04856,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 447.111 232)",
    fill: "#C9C7C2"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    width: 20.3238,
    height: 3.04856,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 482.314 252.323)",
    fill: "#C9C7C2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M347.287 179.701L348.386 180.336L351.102 179.111L352.435 179.88L349.731 181.112L350.831 181.747L353.547 180.523L354.776 181.232L355.992 180.53L354.905 179.903L356.496 179.178L357.673 179.858L358.889 179.156L357.867 178.566L360.26 177.483L359.173 176.856L356.768 177.931L355.422 177.155L357.815 176.072L356.729 175.445L354.323 176.52L353.146 175.841L351.93 176.543L352.952 177.132L351.348 177.849L350.249 177.215L349.033 177.916L349.99 178.469L347.287 179.701ZM352.46 178.491L354.051 177.767L355.397 178.544L353.793 179.261L352.46 178.491Z",
    fill: "#C9C7C2"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    y: 0.499967,
    width: 9.16188,
    height: 9.16188,
    rx: 0.5,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 340.181 166.202)",
    fill: "white",
    stroke: "#ECECEC"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    y: 0.499967,
    width: 245.934,
    height: 19.3238,
    rx: 2.5,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 319.056 173.315)",
    fill: "#F3F5F8",
    stroke: "#ECECEC"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    width: 22.3561,
    height: 6.09713,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 498.162 283.823)",
    fill: "#00D7B3"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    width: 20.3238,
    height: 3.04856,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 399.596 228.952)",
    fill: "#C9C7C2"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    width: 25.4047,
    height: 3.04856,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 355.592 203.549)",
    fill: "#C9C7C2"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    width: 30.4856,
    height: 3.04856,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 425.994 244.194)",
    fill: "#C9C7C2"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    width: 20.3238,
    height: 3.04856,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 461.197 264.516)",
    fill: "#C9C7C2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M326.162 191.895L327.261 192.529L329.977 191.305L331.31 192.074L328.606 193.306L329.706 193.941L332.422 192.716L333.651 193.425L334.867 192.724L333.78 192.096L335.371 191.372L336.548 192.052L337.764 191.35L336.742 190.76L339.135 189.677L338.048 189.05L335.643 190.125L334.297 189.348L336.69 188.266L335.604 187.638L333.198 188.714L332.021 188.034L330.805 188.736L331.827 189.326L330.223 190.043L329.124 189.408L327.908 190.11L328.865 190.663L326.162 191.895ZM331.335 190.685L332.926 189.961L334.272 190.737L332.668 191.454L331.335 190.685Z",
    fill: "#C9C7C2"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    y: 0.499967,
    width: 9.16188,
    height: 9.16188,
    rx: 0.5,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 319.056 178.396)",
    fill: "white",
    stroke: "#ECECEC"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    y: 0.499967,
    width: 245.934,
    height: 19.3238,
    rx: 2.5,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 297.949 185.509)",
    fill: "#F3F5F8",
    stroke: "#ECECEC"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    width: 22.3561,
    height: 6.09713,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 477.055 296.016)",
    fill: "#00D7B3"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    width: 20.3238,
    height: 3.04856,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 378.482 241.145)",
    fill: "#C9C7C2"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    width: 32.518,
    height: 3.04856,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 334.479 215.742)",
    fill: "#C9C7C2"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    width: 30.4856,
    height: 3.04856,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 404.881 256.387)",
    fill: "#C9C7C2"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    width: 20.3238,
    height: 3.04856,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 440.084 276.71)",
    fill: "#C9C7C2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M305.054 204.088L306.154 204.723L308.87 203.498L310.202 204.268L307.499 205.5L308.598 206.134L311.315 204.91L312.543 205.619L313.759 204.917L312.673 204.29L314.264 203.566L315.441 204.245L316.656 203.543L315.635 202.953L318.028 201.871L316.941 201.243L314.535 202.319L313.19 201.542L315.583 200.459L314.496 199.832L312.091 200.907L310.914 200.228L309.698 200.93L310.72 201.52L309.116 202.237L308.016 201.602L306.8 202.304L307.758 202.856L305.054 204.088ZM310.228 202.879L311.819 202.154L313.164 202.931L311.56 203.648L310.228 202.879Z",
    fill: "#C9C7C2"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    y: 0.499967,
    width: 9.16188,
    height: 9.16188,
    rx: 0.5,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 297.949 190.589)",
    fill: "white",
    stroke: "#ECECEC"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    y: 0.499967,
    width: 245.934,
    height: 19.3238,
    rx: 2.5,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 276.824 197.702)",
    fill: "#F3F5F8",
    stroke: "#ECECEC"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    width: 22.3561,
    height: 6.09713,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 455.93 308.209)",
    fill: "#00D7B3"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    width: 20.3238,
    height: 3.04856,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 357.363 253.339)",
    fill: "#C9C7C2"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    width: 20.3238,
    height: 3.04856,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 313.359 227.936)",
    fill: "#C9C7C2"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    width: 30.4856,
    height: 3.04856,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 383.762 268.581)",
    fill: "#C9C7C2"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    width: 20.3238,
    height: 3.04856,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 418.965 288.903)",
    fill: "#C9C7C2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M283.929 216.282L285.029 216.917L287.745 215.692L289.077 216.461L286.374 217.693L287.473 218.328L290.19 217.103L291.418 217.813L292.634 217.111L291.548 216.484L293.139 215.759L294.316 216.439L295.531 215.737L294.51 215.147L296.903 214.064L295.816 213.437L293.41 214.512L292.065 213.736L294.458 212.653L293.371 212.026L290.966 213.101L289.789 212.421L288.573 213.123L289.595 213.713L287.991 214.43L286.891 213.795L285.675 214.497L286.633 215.05L283.929 216.282ZM289.103 215.072L290.694 214.348L292.039 215.125L290.435 215.841L289.103 215.072Z",
    fill: "#C9C7C2"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    y: 0.499967,
    width: 9.16188,
    height: 9.16188,
    rx: 0.5,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 276.824 202.783)",
    fill: "white",
    stroke: "#ECECEC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3359 314.865L119.448 255.916C120.883 255.087 123.209 255.087 124.644 255.916L264.832 336.846L162.72 395.795C161.286 396.624 158.959 396.624 157.524 395.795L17.3359 314.865Z",
    fill: "#13181E",
    fillOpacity: 0.1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17.327 302.332L17.3315 294.851L119.57 243.131C120.975 242.42 123.081 242.431 124.464 243.157L264.823 316.841L264.823 324.314L162.711 383.263C161.277 384.091 158.95 384.091 157.515 383.263L17.327 302.332Z",
    fill: "#2F3A50"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2039 294.865L119.883 236.165C121.079 235.475 123.017 235.475 124.213 236.165L263.968 316.846L162.289 375.545C161.094 376.236 159.155 376.236 157.959 375.545L18.2039 294.865Z",
    fill: "white",
    stroke: "#ECECEC"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9915,
    height: 3.29744,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 41.123 297.612)",
    fill: "#DCDFE5"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    width: 21.9829,
    height: 3.29744,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 52.5469 291.018)",
    fill: "#DCDFE5"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    width: 4.39659,
    height: 3.29744,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 73.5 278.928)",
    fill: "#DCDFE5"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    width: 32.9744,
    height: 3.29744,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 79.209 275.631)",
    fill: "#DCDFE5"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    width: 8.79317,
    height: 3.29744,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 109.658 258.046)",
    fill: "#DCDFE5"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    width: 21.9829,
    height: 3.29744,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 45.877 300.36)",
    fill: "#DCDFE5"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    width: 43.9659,
    height: 3.29744,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 66.8262 288.27)",
    fill: "#DCDFE5"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    width: 4.39659,
    height: 3.29744,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 106.809 265.189)",
    fill: "#DCDFE5"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    width: 21.9829,
    height: 3.29744,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 112.52 261.892)",
    fill: "#DCDFE5"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9915,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 130.578 347.071)",
    fill: "#DCDFE5"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    width: 21.9829,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 142.002 340.476)",
    fill: "#DCDFE5"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    width: 21.9829,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 178.188 319.594)",
    fill: "#DCDFE5"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    width: 4.39659,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 162.955 328.386)",
    fill: "#DCDFE5"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    width: 4.39659,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 199.113 307.504)",
    fill: "#DCDFE5"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    width: 8.79317,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 168.664 325.089)",
    fill: "#DCDFE5"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    width: 8.79317,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 204.828 304.207)",
    fill: "#DCDFE5"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    width: 21.9829,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 134.385 349.269)",
    fill: "#DCDFE5"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    width: 21.9829,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 182 321.792)",
    fill: "#DCDFE5"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    width: 4.39659,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 155.334 337.179)",
    fill: "#DCDFE5"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    width: 4.39659,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 202.922 309.702)",
    fill: "#DCDFE5"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    width: 21.9829,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 161.051 333.882)",
    fill: "#DCDFE5"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866044,
    width: 16.5863,
    height: 16.5863,
    rx: 0.5,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 65.9695 303.541)",
    fill: "#00D7B3",
    stroke: "#00D7B3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M74.633 305.981C76.3117 305.346 78.6587 304.638 80.8919 304.365C80.352 302.22 81.2144 299.423 82.6843 296.685C82.641 300.065 83.498 303.378 85.1585 306.248C81.9295 305.924 78.7085 305.747 74.633 305.981V305.981Z",
    fill: "white"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9915,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 95.3613 293.766)",
    fill: "#DCDFE5"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    width: 21.9829,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 106.781 287.171)",
    fill: "#DCDFE5"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    width: 4.39659,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 127.738 275.081)",
    fill: "#DCDFE5"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    width: 8.79317,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 133.447 271.784)",
    fill: "#DCDFE5"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    width: 21.9829,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 99.1602 295.964)",
    fill: "#DCDFE6"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    width: 4.39659,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 120.109 283.874)",
    fill: "#DCDFE6"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    width: 21.9829,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 125.826 280.577)",
    fill: "#DCDFE6"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    width: 54.9573,
    height: 4.39659,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 88.7051 289.919)",
    fill: "#3E495F"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866044,
    width: 16.5863,
    height: 16.5863,
    rx: 0.5,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 88.8074 316.73)",
    fill: "#00D7B3",
    stroke: "#00D7B3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4924 319.17C99.1711 318.535 101.518 317.827 103.751 317.554C103.211 315.409 104.074 312.612 105.544 309.874C105.5 313.254 106.357 316.567 108.018 319.437C104.789 319.113 101.568 318.936 97.4924 319.17V319.17Z",
    fill: "white"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9915,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 118.203 306.955)",
    fill: "#DCDFE5"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    width: 21.9829,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 129.623 300.36)",
    fill: "#DCDFE5"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    width: 4.39659,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 150.58 288.27)",
    fill: "#DCDFE5"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    width: 8.79317,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 156.289 284.973)",
    fill: "#DCDFE5"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    width: 21.9829,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 122.006 309.153)",
    fill: "#DCDFE5"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    width: 4.39659,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 142.955 297.063)",
    fill: "#DCDFE5"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    width: 21.9829,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 148.672 293.765)",
    fill: "#DCDFE5"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    width: 54.9573,
    height: 4.39659,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 111.533 303.108)",
    fill: "#3E495F"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866044,
    width: 16.5863,
    height: 16.5863,
    rx: 0.5,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 111.649 329.918)",
    fill: "white",
    stroke: "#ECECEC"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9915,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 141.047 320.144)",
    fill: "#DCDFE5"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    width: 21.9829,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 152.467 313.549)",
    fill: "#DCDFE5"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    width: 4.39659,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 173.424 301.459)",
    fill: "#DCDFE5"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    width: 8.79317,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 179.133 298.162)",
    fill: "#DCDFE5"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    width: 21.9829,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 144.846 322.342)",
    fill: "#DCDFE5"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    width: 4.39659,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 165.795 310.252)",
    fill: "#DCDFE5"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    width: 21.9829,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 171.512 306.955)",
    fill: "#DCDFE5"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    width: 54.9573,
    height: 4.39659,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 134.375 316.297)",
    fill: "#3E495F"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    width: 21.9829,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 196.307 331.134)",
    fill: "#DCDFE5"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    width: 4.39659,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 217.256 319.044)",
    fill: "#DCDFE5"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    width: 8.79317,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 222.973 315.747)",
    fill: "#DCDFE5"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    width: 4.39659,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 209.641 327.837)",
    fill: "#3E495F"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    width: 21.9829,
    height: 2.19829,
    rx: 1,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 215.354 324.54)",
    fill: "#3E495F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M153.209 353.244C155.599 353.021 157.01 352.519 158.438 351.775L163.754 354.844C165.443 355.819 164.943 356.612 163.814 359.366C159.045 360.018 157.67 360.307 155.98 359.332L150.664 356.263C151.953 355.439 152.823 354.624 153.209 353.244V353.244ZM151.796 352.429C151.516 354.428 150.417 355.148 148.465 356.275L154.87 359.973C157.426 361.449 159.871 360.807 165.123 360.122C166.309 357.09 167.421 355.679 164.865 354.203L158.46 350.505C156.507 351.632 155.26 352.267 151.796 352.429Z",
    fill: "#FC8A63"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M457.967 411.537C459.371 410.726 461.637 410.706 463.083 411.492L524.092 444.646L427.883 500.037C426.448 500.863 424.124 500.862 422.69 500.035L363.68 465.968L457.967 411.537Z",
    fill: "#13181E",
    fillOpacity: 0.1
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M458.194 398.698C459.527 398.031 461.493 398.006 462.877 398.636L522.101 425.633L522.096 442.111C522.096 442.745 521.603 443.347 520.754 443.75L427.863 487.78C426.402 488.472 424.27 488.412 422.933 487.64L363.684 453.436L363.685 445.962L458.194 398.698Z",
    fill: "#2F3A50"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M462.657 391.831L521.231 425.646L427.455 479.783C426.259 480.473 424.32 480.473 423.125 479.783L364.551 445.968L458.327 391.831C459.523 391.141 461.462 391.141 462.657 391.831Z",
    fill: "white",
    stroke: "#ECECEC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M443.769 404.868C445.191 404.047 447.493 404.038 448.933 404.849L497.707 432.309C499.173 433.135 499.188 434.492 497.74 435.328L467.581 452.738C466.159 453.56 463.858 453.568 462.418 452.757L413.643 425.297C412.177 424.472 412.163 423.114 413.61 422.278L443.769 404.868Z",
    fill: "#00D7B3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M464.114 433.368C464.123 432.781 464.791 432.265 465.765 432.094C466.459 431.973 467.014 431.672 467.268 431.279C467.522 430.886 467.444 430.448 467.057 430.094C466.515 429.597 466.593 428.955 467.253 428.508C467.723 428.189 467.909 427.762 467.754 427.352C467.601 426.943 467.125 426.599 466.466 426.422C465.545 426.173 465.011 425.608 465.147 425.027C465.243 424.612 464.999 424.194 464.486 423.898C463.973 423.602 463.25 423.461 462.531 423.517C461.526 423.597 460.546 423.288 460.116 422.756C459.809 422.377 459.213 422.102 458.504 422.013C457.796 421.924 457.055 422.031 456.502 422.303C455.727 422.683 454.615 422.729 453.756 422.416C453.142 422.192 452.383 422.147 451.703 422.294C451.024 422.44 450.502 422.761 450.292 423.162C449.996 423.724 449.103 424.109 448.086 424.115C447.361 424.118 446.68 424.317 446.245 424.652C445.81 424.987 445.672 425.421 445.87 425.824C446.148 426.388 445.759 426.992 444.908 427.313C444.302 427.543 443.915 427.922 443.863 428.34C443.812 428.758 444.101 429.166 444.644 429.442C445.407 429.831 445.643 430.46 445.23 430.996C444.933 431.378 444.964 431.818 445.313 432.186C445.66 432.553 446.285 432.806 447.002 432.87C448.007 432.958 448.797 433.414 448.949 433.994C449.058 434.408 449.496 434.769 450.133 434.969C450.77 435.17 451.533 435.187 452.195 435.017C453.123 434.778 454.213 434.914 454.886 435.355C455.365 435.669 456.071 435.836 456.795 435.805C457.518 435.776 458.176 435.553 458.573 435.202C459.131 434.712 460.176 434.486 461.154 434.647C461.852 434.761 462.602 434.681 463.183 434.431C463.764 434.18 464.108 433.786 464.114 433.368V433.368ZM451.376 430.448L451.28 426.829L453.906 426.829L454.003 428.931L462.083 428.874L462.083 430.39L451.376 430.448Z",
    fill: "white"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    width: 60.9713,
    height: 6.09713,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 459.617 395.67)",
    fill: "#C9C7C2"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    width: 60.9713,
    height: 3.46723,
    rx: 1,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 457.342 396.985)",
    fill: "url(#paint0_linear_701_270)"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    width: 18.0355,
    height: 6.36546,
    rx: 2,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 405.004 428.291)",
    fill: "#DCDFE5"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    width: 18.0355,
    height: 6.36546,
    rx: 2,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 396.736 433.064)",
    fill: "#DCDFE5"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    width: 18.0355,
    height: 6.36546,
    rx: 2,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 388.465 437.838)",
    fill: "#DCDFE5"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    width: 18.0355,
    height: 6.36546,
    rx: 2,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 380.193 442.612)",
    fill: "#3E495F"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    width: 18.0355,
    height: 6.36546,
    rx: 2,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 423.373 438.899)",
    fill: "#DCDFE5"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    width: 18.0355,
    height: 6.36546,
    rx: 2,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 415.109 443.673)",
    fill: "#DCDFE5"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    width: 18.0355,
    height: 6.36546,
    rx: 2,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 406.842 448.447)",
    fill: "#DCDFE5"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    width: 18.0355,
    height: 6.36546,
    rx: 2,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 398.568 453.22)",
    fill: "#DCDFE5"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    width: 18.0355,
    height: 6.36546,
    rx: 2,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 441.758 449.508)",
    fill: "#DCDFE5"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    width: 18.0355,
    height: 6.36546,
    rx: 2,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 433.486 454.281)",
    fill: "#DCDFE5"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    width: 18.0355,
    height: 6.36546,
    rx: 2,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 425.213 459.055)",
    fill: "#DCDFE5"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    width: 18.0355,
    height: 6.36546,
    rx: 2,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 416.949 463.829)",
    fill: "#3E495F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M249.711 104.5L233.211 94.8687",
    stroke: "#6311F4",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M367.711 406.5L351.211 396.869",
    stroke: "#6311F4",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M247.711 253.5L230.711 263.5",
    stroke: "#6311F4",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M213.98 27.1449V13.7476L202.551 7.61963V20.4932L213.98 27.1449Z",
    fill: "#2F3A50"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M227.313 6.66724L213.979 13.7154V27.2801L227.313 19.5729V6.66724Z",
    fill: "#E8EBEF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M202.551 7.70287L214.105 14.4169L227.481 6.71399L215.771 0L202.551 7.70287Z",
    fill: "#F3F5F8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M222.796 9.42057L211.19 2.65454L207.391 4.84049L219.049 11.7627V16.3427L220.767 13.272L222.796 14.1047V9.42057Z",
    fill: "#FC8A63"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M123.17 71.0952V52.7869L107.551 44.4126V62.0052L123.17 71.0952Z",
    fill: "#2F3A50"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M141.392 43.1111L123.17 52.7428V71.28L141.392 60.7476V43.1111Z",
    fill: "#E8EBEF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M107.551 44.5265L123.341 53.7016L141.62 43.1751L125.617 34L107.551 44.5265Z",
    fill: "#F3F5F8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M135.217 46.8737L119.356 37.6274L114.164 40.6147L130.096 50.0743V56.3333L132.443 52.1369L135.217 53.2749V46.8737Z",
    fill: "#FC8A63"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M240.17 64.0952V45.7869L224.551 37.4126V55.0052L240.17 64.0952Z",
    fill: "#2F3A50"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M258.392 36.1111L240.17 45.7428V64.28L258.392 53.7476V36.1111Z",
    fill: "#E8EBEF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M224.551 37.5265L240.341 46.7016L258.62 36.1751L242.617 27L224.551 37.5265Z",
    fill: "#F3F5F8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M252.217 39.8737L236.356 30.6274L231.164 33.6147L247.096 43.0743V49.3333L249.443 45.1369L252.217 46.2749V39.8737Z",
    fill: "#FC8A63"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M177.308 97.798V50.0237L136.551 28.1714V74.0781L177.308 97.798Z",
    fill: "#2F3A50"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M224.86 24.7749L177.311 49.9084V98.28L224.86 70.7964V24.7749Z",
    fill: "#E8EBEF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M136.551 28.4683L177.753 52.4103L225.452 24.942L183.692 1L136.551 28.4683Z",
    fill: "#F3F5F8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M208.741 34.5931L167.353 10.4656L153.805 18.2606L195.378 42.945V59.2775L201.503 48.3273L208.741 51.2968V34.5931Z",
    fill: "#00D7B3"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M141.36 119.046V95.8265L121.551 85.2058V107.517L141.36 119.046Z",
    fill: "#2F3A50"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M164.47 83.5552L141.359 95.7706V119.28L164.47 105.923V83.5552Z",
    fill: "#E8EBEF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M121.551 85.3501L141.576 96.9864L164.758 83.6363L144.463 72L121.551 85.3501Z",
    fill: "#F3F5F8"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M156.638 88.3271L136.522 76.6006L129.938 80.3891L150.143 92.3862V100.324L153.12 95.0021L156.638 96.4454V88.3271Z",
    fill: "#FC8A63"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M457 397L509.5 427.377L512 426C526.5 403 546.5 397 568 396V387.5L507.729 365.035C477.025 363.867 461.45 382.677 457 397Z",
    fill: "#13181E",
    fillOpacity: 0.1
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M457 397L509.5 427.377V425.5C518.678 391.959 554.731 386.585 568.428 387.489L507.729 365.035C477.025 363.867 461.45 382.677 457 397Z",
    fill: "white",
    stroke: "#ECECEC",
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M476.111 378.34L488.005 384.586",
    stroke: "#3E495F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M492.121 386.394L519.563 401.93",
    stroke: "#DCDFE5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M470.088 383.563L486.484 392.465",
    stroke: "#3E495F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M492.248 395.164L510.694 405.629",
    stroke: "#DCDFE5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M464.848 390.482L477.144 397.158",
    stroke: "#3E495F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M481.279 398.55L508.721 414.086",
    stroke: "#DCDFE5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_701_270",
    x1: 30.4856,
    y1: 0,
    x2: 30.4856,
    y2: 3.46723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9C7C2",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient10);
export default __webpack_public_path__ + "static/media/client10.3509c8b7340701026a124ef333664f49.svg";
export { ForwardRef as ReactComponent };